<ng-container *ngIf="contentHeader">
  <div class="content-header row align-items-center">
    <div class="content-header-left col-md-8 col-12 mb-md-0 mb-1">
      <div class="row breadcrumbs-top">
        <div class="col-12 d-flex align-items-center">
          <h2 class="content-header-title mb-0">
            {{ contentHeader.headerTitle }}
          </h2>
          <app-breadcrumb [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
        </div>
      </div>
    </div>
    <ng-container *ngIf="contentHeader.actionButton">
      <div class="content-header-right text-md-right col-md-4 col-12">
        <div class="breadcrum-right">
          <button (click)="backToggle()"
              class="btn btn-success btn-round btn-kembali d-inline-flex align-items-center"
              type="button"
              rippleEffect>
              <span [data-feather]="'arrow-left'" style="width: 20px; height: 20px;"></span>
              <span class="ml-50 btn-kembali-text">Kembali</span>
            </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
